/**
 * TaxaConversaoWidget — % de orcamentos APROVADOS / enviados.
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterPainel } from "../../../services/comercialPainel";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "taxa_conversao",
  label: "Taxa de conversao",
  descricao: "O mesmo número da Taxa conversão do Painel Comercial (mês atual).",
  categoria: "Comercial",
  permissoes: ["comercial:metricas"],
  tamanho_default: "S",
  essencial: true,
};

export async function fetchData(request) {
  return await obterPainel(request);
}

// Lia `dados.taxa_conversao` (um objeto {taxa, ganhos, enviados}) como número
// e mostrava "NaN%". Agora le os mesmos campos do card do painel (mês atual).
export function Widget({ dados }) {
  const tx = dados?.taxa_conversao?.taxa ?? null;
  const aprovados = dados?.taxa_conversao?.ganhos ?? null;
  const enviados = dados?.taxa_conversao?.enviados ?? null;
  const porLeads = dados?.fontes?.taxa_conversao === "leads";
  return (
    <>
      <CardBody>
        <KpiValor>
          {tx != null ? `${Number(tx).toFixed(1)}%` : "—"}
        </KpiValor>
        <KpiSub>
          {aprovados != null && enviados != null
            ? porLeads
              ? `${aprovados} finalizados de ${enviados} leads`
              : `${aprovados} aprovados de ${enviados} enviados no mês`
            : "mês atual"}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/comercial/painel">Ver painel</LinkLight>
      </CardFooter>
    </>
  );
}
